export default "__VITE_ASSET__CLM2TBC6__"